<!-- ./src/pages/admin/Products.vue -->
<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Empresas
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              small 
              color="blue"
              class="mr-2 ml-2" 
              @click="novo()">
              Nova Empresa
            </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="empresas"
            :search="search"
            class="compact-form"
          >
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Cadastrar Empresa</span>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save()" ref="form"  class="compact-form">
            <v-tabs v-model="active">
            <v-tab :key="0" ripple>
              Dados
            </v-tab>
            <v-tab :key="1" ripple>
              Banco Brasil
            </v-tab>
            <v-tab :key="1" ripple>
              Anexos
            </v-tab>
            
            <v-tabs-items v-model="active">
              <v-tab-item :key="2">
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">Nome</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.nome"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">CNPJ</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="CNPJ"
                      v-model="model.CnpjCpf"
                      v-mask="maskCNPJ" 
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">CEP</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.cep"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">logradouro</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.logradouro"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">bairro</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.bairro"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">cidade</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.cidade"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">estadoUF</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.estadoUF"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">Token Iugu</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="Token Iugu"
                      v-model="model.TokenIugu"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">numeroConvenio</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.numeroConvenio"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">numeroCarteira</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.numeroCarteira"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">numeroVariacaoCarteira</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.numeroVariacaoCarteira"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">agencia</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.agencia"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">agenciaDigito</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.agenciaDigito"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">conta</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.conta"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">contaDigito</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.contaDigito"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">Web</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.web"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">developer_application_key</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.devappkey"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">client_id</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="client_id"
                      v-model="model.client_id"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">client_secret</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="client_secret"
                      v-model="model.client_secret"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">Nosso Numero</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.nosso_numero"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3"  >
                    <v-subheader class="justify-end">Nosso Numero Digito</v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.nossoNumeroDigito"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :key="3">
                <v-container v-show="!carregando">
                  <v-row
                    class="fill-height"
                    align-content="center"
                    justify="center">
                    <v-col
                      class="subtitle-1 text-center"
                      cols="12">
                      <input
                          type="file"
                          ref="image"
                          :multiple="true"
                          @change="onFileChangePdf"
                        >
                    </v-col>
                  </v-row>
                </v-container>
                <v-data-table
                  :headers="headersPdfs"
                  :items="model.images">
                  <template v-slot:item.descricao="{ item }">
                    <a :href="item.image" target="_blank" :download="item.descricao">{{ item.descricao }}</a>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      @click="deleteImage(item)">
                      delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
            
          </v-tabs>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="clear()">Fechar</v-btn>
          <v-btn small color="blue darken-1" @click.native="save()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="dialogConfirmation = false">Não</v-btn>
          <v-btn small color="blue darken-1" @click.native="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
  import empresa from "@/services/empresa";
  import { mapMutations } from "vuex";

  export default {
    name: 'home',
    data () {
      return {
        search: '',
        loading: true,
        dialog: false,
        carregando: false,
        dialogConfirmation: false,
        editando: false,
        excluindo: {},
        empresas: [],
        active: 0,
        maskCNPJ: '##.###.###/####-##',
        options: ['Cliente', 'Admin', 'Funcionario',  'Financeiro', 'Cadastradores'],
        model: {
          nome: "",
        },
        headers: [
          {
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'nome'
          },
          { text: 'Ações', value: 'action', sortable: false }
        ],
        headersPdfs: [{
            text: 'Nome  Anexo',
            align: 'left',
            sortable: true,
            value: 'descricao',
          },
          { text: 'Ações', value: 'action', sortable: false },
        ],
      }
    },
    async created () {
      this.empresas = await empresa.getAll();
    },
    methods: {
      novo: function () {
        this.dialog = true;
        this.model = {
          nome: "",
        }
      },
      deleteItem: async function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          let res = await empresa.remove(even)
          this.dialogConfirmation = false;
          this.excluindo = null;
          this.empresas = await empresa.getAll();
        }
      },
      editItem: function (even) {
        //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
        this.dialog = true;
        this.editando = true;
        this.model = {...even};
        this.$forceUpdate();
        this.model.internal = undefined;
        this.model.flags = undefined;
        
      },
      save: async function () {
        if (this.$refs.form.validate()) {
          let res = await empresa.save(this.model);
          if (res.data && res.data.error) {
            this.message = res.data.error.data;
            this.dialogError = true;
          } else {
            this.clear();
            this.empresas = await empresa.getAll();
          }
            
            this.editando = false;
        }
        
      },
      clear: function () {
        this.model = {
          name: "",
          username: "",
          password: ""
        }
        this.editando = false;
        this.$validator.reset()
        this.dialog = false;
      },
      onFileChangePdf: async function ($event){
        this.setLoading(true);
        try {
          const files = $event.target.files || $event.dataTransfer.files;
          if (files) {
            var payload = new FormData();
            payload.set('empresa', this.model._id);
            if (files.length > 0) {
              for (var i = 0; i < files.length; i++) {
                var file = files[i];
                payload.append('filename', file);
              }
              let res = await empresa.saveImage(payload);
              
              this.model = await empresa.getId(this.model._id);
              this.setLoading(false);
            }
          }
        } catch (e) {
          this.setLoading(false);

        }
      },
      
      async deleteImage (item) {
        this.setLoading(true);
        let res = await empresa.removeImage(item, this.model._id);
        this.model = await empresa.getId(this.model._id);
        
        this.setLoading(false);
      },
      ...mapMutations({
        setLoading: "setLoading",
        setDevedor: "setDevedor",
      }),

    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/user/Empresas.vue